<template>
   <div  class="edicion_block">
        <div  @click="show.s1=!show.s1" class="navcola manito" :class="{ 'navcola--open': show.s1 }" style="border-top:0px !important;">
            <span class="navcola-title"><img class="navcola-icon" :src="require('@/assets/images/blocks/icon_contenidos.svg')" /><h4>{{$t('bc.content')}}</h4></span>
            <Icon :icon="show.s1 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
        </div>
        <div :class="'contenido '+show.s1" v-show-slide="show.s1">
            <div class="row form_row">
                <div class="col-12">
                    <div class="form-group">
                        <textarea maxlength="400"  rows="7" type="text" :placeholder="$t('general.entervalue')" v-model="valor.value" @input="emitChange" style="width:100% !important;border:0px;overflow:hidden;" ></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div  @click="show.s2=!show.s2" class="navcola manito" :class="{ 'navcola--open': show.s2 }" style="border-top:0px !important;">
            <span class="navcola-title"><img class="navcola-icon" :src="require('@/assets/images/blocks/icon_design.svg')" /><h4>{{$t('bc.design')}}</h4></span>
            <Icon :icon="show.s2 ? 'ph:caret-up-light' : 'ph:caret-down-light'" style="font-size: 18px;" />
        </div>
        <div :class="'contenido '+show.s2" v-show-slide="show.s2">
            <div class="row form_row">
                <div class="col-12">
                    <sizePicker :min="400" :max="900" :interval="100" :label="$t('pickers.weight')" :unit="''"  v-model="valor.weight" @input="emitChange" />
                </div>
            </div>

            <div class="row form_row">

                <div class="col-lg-6">
                    <sizePicker   v-model="valor.size" @input="emitChange" />
            
                </div>
                <div class="col-lg-6">

                    <colorPicker :color="valor.color"   v-model="valor.color" @input="emitChange" />
                
                </div>
            </div>
            <div class="row form_row">
                <div class="col-lg-6">
                    <sizePicker :label="$t('pickers.inter')" v-model="valor.lineh" @input="emitChange" />
        
                </div>
            </div>
            <div class="row form_row">
                <div class="col-12">
                    <fontPicker v-model="valor.family" @input="emitChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>





import colorPicker from '../dinputs/colorPicker'
import sizePicker from '../dinputs/sizePicker'
import fontPicker from '../dinputs/fontPicker'

export default {
	props: ['value'],
	data() {
		return { 
            show:{s1:false,s2:false },
            valor:this.value,
		}
    },
    components:{
        'colorPicker':colorPicker,
        'sizePicker':sizePicker,
        'fontPicker':fontPicker
    },
    watch: {
        value(newVal) {
            if (JSON.stringify(newVal) !== JSON.stringify(this.valor)) {
                this.valor = newVal;
            }
        }
    },
    methods: {
        emitChange() {
            this.$emit('input', { ...this.valor });
        }
    }
}
</script>

